const styles = (theme) => ({
  root: {
    padding: '10px 24px 10px 24px',
  },
  avatar: {
    color: theme.palette.custom.maintenance,
    marginTop: '0px',
    borderRadius: '50px',
    border: `1px solid ${theme.palette.border.lighter}`,
    padding: '8px',
    width: '42px',
    height: '42px',
  },
  expandIcon: {
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
      borderRadius: '5px',
    },
  },
  expansionPanelDetails: {
    marginLeft: '-20px',

    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
  },
  expansionPanelTitle: {
    fontWeight: '600',
    fontSize: '20px',
    marginLeft: '15px',
    alignSelf: 'center',
  },
  expansionPanelSummaryDiv: {
    display: 'flex',
    alignItems: 'flex-start',
  },
});

export default styles;
